import { Field } from "formik";
import { FormControl, FormHelperText, FormErrorMessage, FormLabel, Select } from "@chakra-ui/react";

// This component must be used inside <Formik> and <Form> wrappers
export const SelectField = ({
  id, 
  onChange, 
	children, 
  placeholder,
  defaultValue = "", 
  label, 
  errorMessage, 
  helperMessage
}) => {
  // todo: move from errorMessage prop to form.errors (add Formik built-in validation)
  return (
    <Field name={id} as="select">
      {({field, form}) => {
        const { onChange: _onChange, ...restField } = field;
        const isError = !!(form.errors[id] && form.touched[id]);

        const handleChange = (e) => {
          onChange && onChange(e);
          _onChange(e)
        };
        return (
          <FormControl isRequired isInvalid={isError}>
            {label && <FormLabel mb="5px" fontWeight="semibold">{label}</FormLabel>}
            <Select {...restField} defaultValue={defaultValue} onChange={handleChange}>
              {placeholder && <option hidden disabled value="">{placeholder}</option>}
              {children}
            </Select>
            {!isError && helperMessage && (<FormHelperText mt="5px" color="blackAlpha.600" fontSize="0.8em">{helperMessage}</FormHelperText>)}
            {isError && (errorMessage) && (<FormErrorMessage>{errorMessage}</FormErrorMessage>)}
          </FormControl>
        )
      }}
    </Field>
  );
};
